import { motion } from 'framer-motion';

export default function LoadingScreen() {
  return (
    <div className="fixed inset-0 z-[100] flex flex-col items-center justify-center bg-slate-50">
      <motion.div 
        initial={{ opacity: 0, scale: 0.8 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="flex flex-col items-center"
      >
        <div className="w-20 h-20 relative mb-6">
          <div className="absolute inset-0 rounded-2xl bg-primary-100 animate-ping opacity-75"></div>
          <div className="relative flex items-center justify-center w-full h-full bg-primary-600 rounded-2xl shadow-xl shadow-primary-600/30">
            <span className="text-white font-display font-bold text-3xl">S</span>
          </div>
        </div>
        <h2 className="text-2xl font-display font-bold text-slate-900 mb-2">SchoolERP</h2>
        <div className="flex space-x-2">
          <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '0ms' }}></div>
          <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '150ms' }}></div>
          <div className="w-2 h-2 bg-primary-600 rounded-full animate-bounce" style={{ animationDelay: '300ms' }}></div>
        </div>
      </motion.div>
    </div>
  );
}
